import AuthLayout from "src/containers/AuthLayout";
import type { NextPageWithLayout } from "../_app";
import { GetServerSideProps } from "next";
import { allSettled, fork, serialize } from "effector";
import { AuthView } from "@components/views/AuthView/view";
import { updateAuthProcess } from "../../process/authProcess/model/public";
import Head from "next/head";

const LoginPage: NextPageWithLayout = () => {
	return (
		<>
			<Head>
				<title>Авторизация на обучающую платформу Selfschool</title>
				<meta property="og:title" content="Авторизация на обучающую платформу Selfschool" />
				<meta name="description" content="Авторизация в обучающей платформе SelfSchool" />
				<meta property="og:description" content="Авторизация в обучающей платформе SelfSchool" />
			</Head>
			<AuthView />
		</>
	);
};

export default LoginPage;

LoginPage.getLayout = AuthLayout;

export const getServerSideProps: GetServerSideProps = async () => {
	const scope = fork();

	await allSettled(updateAuthProcess, {
		scope,
		params: {
			stage: "login",
		},
	});

	return {
		props: {
			initialState: serialize(scope),
		},
	};
};
